import { rootActions, useAppDispatch, useAppSelector } from '../dal/store';
import { useWindowResizeObserver } from '../../../domain/animations/animations-provider';
import React, { Fragment, useEffect, useRef } from 'react';
import { initEqualHeight } from '../../list-page/services/list-page-provider';
import CheckIcon from '../../../ui/svg/common/check-v';
import Bundle from './bundle';

const tdHideMutualStyle= {
    width: '20%',
    verticalAlign: 'bottom',
    height: 'inherit,'
};

const Table = () => {
    const dispatch = useAppDispatch();
    const data = useAppSelector(store => store.root.data);
    const isMutualHidden = useAppSelector(store => store.root.isMutualHidden);

    const [ width ] = useWindowResizeObserver();
    const containerRef = useRef<HTMLTableElement>(null);

    /**
     * titles and taglines should have equal height in grid view
     */
    useEffect(() => {
        (async () => {
            await initEqualHeight(
                containerRef.current,
                width,
                'grid',
                4,
                4,
                4
            );
        })();
    }, [
        // update on every jPList action changes,
        // on document width change, and on products change
        width,
    ]);

    const toggleMutual = () => {
        dispatch(
            rootActions.main({
                isMutualHidden: !isMutualHidden,
            })
        );
    };

    const bundlesCount = data?.bundles.length || 0;
    const emptyBundles = 4 - bundlesCount;

    return (
        <div className="w-screen lg:w-full overflow-auto">
            <table className="w-1200-px md:w-full h-full" ref={ containerRef }>
                <tbody>
                <tr>
                    <td style={ tdHideMutualStyle }>
                        <button type="button" className="w-btn w-auto mb-4" onClick={ toggleMutual }>
                            { isMutualHidden && <span>Show Mutual</span> }
                            { !isMutualHidden && <span>Hide Mutual</span> }
                        </button>
                    </td>

                    {
                        data?.bundles.map(bundle => <Bundle bundle={ bundle } key={ bundle.skuid } /> )
                    }

                    {
                        emptyBundles > 0 &&
                        <>{[...Array(emptyBundles)].map((_el, index) => {
                            return <td key={ `empty-${ index }` }></td>
                        })}</>
                    }
                </tr>

                {
                    data?.plugins.map(plugin => {
                        const hideRow = isMutualHidden && !!plugin.isAllIncludedTheSame;
                        if(hideRow) return <Fragment key={ plugin.documentName }></Fragment>;

                        return (
                            <tr key={ plugin.documentName }>
                                <td className="py-2">{ plugin.documentName }</td>

                                {
                                    plugin.included?.map((includedItem, i) => {
                                        return (
                                            <td key={ `${  plugin.documentName }-${ i }` } className="border-l border-t">
                                                { includedItem && <CheckIcon width="15px" color="#000" classes="mx-auto" /> }
                                            </td>
                                        )
                                    })
                                }

                                {
                                    emptyBundles > 0 &&
                                    <>{[...Array(emptyBundles)].map((_el, index) => {
                                        return <td key={ `empty-included-${ index }` }></td>
                                    })}</>
                                }
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        </div>
    )
};

export default Table;